import _extends from "@babel/runtime/helpers/esm/extends";
import { ELanguage } from '../common';
import { fieldsIBaseModel } from './base';
export let EMessageTemplateType;
(function (EMessageTemplateType) {
  EMessageTemplateType["Chat"] = "chat";
  EMessageTemplateType["Broadcast"] = "broadcast";
  EMessageTemplateType["Followup"] = "followup";
  EMessageTemplateType["Partial"] = "partial";
})(EMessageTemplateType || (EMessageTemplateType = {}));
export const fieldsMessageTemplate = _extends({}, fieldsIBaseModel, {
  answers: {
    type: 'Object',
    array: true
  },
  key: {
    type: 'Text'
  },
  language: {
    type: 'Option',
    values: ELanguage
  },
  layout: {
    type: 'Text'
  },
  subject: {
    type: 'Text'
  },
  template: {
    type: 'Text'
  },
  title: {
    type: 'Text'
  },
  type: {
    type: 'Option',
    values: EMessageTemplateType,
    array: true
  },
  versionDescription: {
    type: 'Text'
  }
});